export const IS_LOGINED = "ilg";
